import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import LoginModel from '../../../../../models/user.model';
import { AppCommon } from '../../../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../../../models-views/sourcing-needs-v2.view.model';
import { StandardResponseModel } from '../../../../../models/project.model';

@Component({
  selector: 'app-sn-form-speaker-talent-v2',
  templateUrl: './sn-form-speaker-talent-v2.component.html',
  styleUrls: ['./sn-form-speaker-talent-v2.component.scss'],
  standalone: false
})
export class SnFormSpeakerTalentV2Component implements OnInit, OnChanges {
  @Input() eventId: number | null = null;
  @Input() data: any;
  @Output() closeModal = new EventEmitter<'success' | 'cancel'>();
  
  form!: FormGroup;
  isEdit: boolean = true;
  isView: boolean = false;
  existingData: any = null;

  speakerTalentOptionsResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

  constructor(
    private fb: FormBuilder, 
    private vm: SourcingNeedV2ViewModel,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.vm.parentSnFormSpeakerTalentV2Component = this;
    this.initForm();
    this.vm.subscribeToSpeakerTalentOptions(this.speakerTalentOptionsResponseModel);
    this.vm.getSpeakerTalentOptions();
    
    setTimeout(() => {
      this.handleInputData();
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.handleInputData();
    }
  }

  handleInputData(): void {

    if (this.data) {
      this.existingData = this.data;
      this.isView = false;
      this.isEdit = true;
      this.form.patchValue(this.mapApiToForm(this.data));
    } else {
      this.existingData = null;
      this.isView = false;
      this.isEdit = true;
      this.form.reset();
      this.form.enable();
      this.cdr.detectChanges();
    }
  }

  mapApiToForm(data: any): any {
    // Map API response to form fields - handle both array and object with details
    if (Array.isArray(data)) {
      return {
        speaker_on_stage_talent: data.map((item: any) => item.id) || [],
      };
    } else {
      return {
        speaker_on_stage_talent: data?.speaker_details?.map((item: any) => item.id) || [],
      };
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      speaker_on_stage_talent: [[], Validators.required],
    });
  }

  onSave(): void {
    if (this.form.valid) {
      const payload = this.form.value;
      payload.id = this.eventId;
      
      const loggedInUser = AppCommon.getloggedInObject();
      const userId = loggedInUser?.user?.id;
      
      payload.modified_by = userId;
      payload.is_speaker_on_stage_talent = payload.speaker_on_stage_talent?.length > 0 ? true : false;
      
      this.vm.updateSourcingNeed(payload, 'sn-form-speaker-talent-v2');
    }
  }

  speakerTalentAdded() {
    this.closeModal.emit('success');
    
    // Refresh parent component data
    if (this.eventId) {
      this.vm.getSouringNeedbyId(this.eventId, 'cet-sourcing-needs-v2');
    }
  }

  onEdit(): void {
    this.isEdit = true;
    this.isView = false;
    this.form.enable();
  }

  onCancel(): void {
    this.closeModal.emit('cancel');
  }
}